
import {  Card, Col, message, Radio, Row, Select, Slider, Space, Statistic, Table, TablePaginationConfig, Tag, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import DragTableRow from 'src/components/DragTableRow'
import usePage from 'src/hooks/usePage'
import {
  getGameUsageChart,
  getGameUsageReportMetrics,
  removeEmptyAttributes,
  searchAdsReport,
  searchGameReport,
} from 'src/api/reports'

import { useCategoryMap } from 'src/hooks/GamesCategoryContext'
import AreaChart from 'src/components/Charts/AreaChart'
import { chartDateType, deviceMarks, deviceMarksAndroid, mncmccOptions, userType } from 'src/constants'
import { formatTimeWithSuffix } from 'src/utils/numberUtils'
import moment from 'moment'
import HourlyAppUsageChart from 'src/components/Charts/HourlyAppUsageChart'
import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import { Link, useNavigate } from 'react-router-dom'
import { SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface'
import AdsReportPage from '../Reports/AdsReport/adsReport'
import AllGamesReportSearch from './allGamesReportSearch'
import { manualFetch } from 'src/utils/fetch'
import PrivateImage from 'src/components/PrivateImage'
import { searchAllGames } from 'src/api/metaverse'
import EditGradientIcon from 'src/components/EditGradientIcon'
import ViewEyeIcon from 'src/components/ViewEyeIcon'

const { Column } = Table

const AllGamesReportPage: React.FC = () => {
  const {
    pageData,
    onQuery,
    appendSearchForm,
    appendSearchFormMap,
    submitSearchForm,
    fetchList,
    queryObj,
    searchForm,
  } = usePage({
    getData: searchAllGames,
    searchData: searchAllGames,
    searchType: 'POST',
  })
  const { categoryMap, filterGamesByType, findCategoriesForGame } =
    useCategoryMap()
 const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [imageUrl, setImageUrl] = useState<string | null>(null)
 
  pageData.data.forEach((gameData) => {
    const categories = findCategoriesForGame(gameData.gameId)
    gameData.categories = categories
  })
  const appUsageChartColor = ['#181c84', '#000000', '#5BB2FF']
  type SortItem = { field: string; order: 'asc' | 'desc' };
   const fetchImage = async (url) => {
    const response = await manualFetch(url, {
      headers: {
        accept: 'image/*',
      },
    })
    const imageBlob = await response.blob()
    return URL.createObjectURL(imageBlob)
  }

const handleTableChange = (
  pagination: TablePaginationConfig,
  _filters: Record<string, (string | number | boolean)[] | null>,
  sorter: SorterResult<any> | SorterResult<any>[],
  extra: TableCurrentDataSource<any>
) => {
  const current = pagination.current ?? 1;
  const pageSize = pagination.pageSize ?? (parseInt(pageData.query.pageSize) || 10);


  const sorterArr = Array.isArray(sorter) ? sorter : [sorter];
  const sorts: SortItem[] = sorterArr
    .filter((s) => s && s.field && s.order)
    .map((s) => ({
      field: String(s.field),
      order: s.order === 'ascend' ? 'asc' : 'desc',
    }));


  if (extra.action === 'paginate') {
   
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
    });
    return;
  }

  
  if (extra.action === 'sort') {
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
      sorts: JSON.stringify(sorts),
    });
    return;
  }

  
  if (extra.action === 'filter') {
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
      sorts: JSON.stringify(sorts),
    });
  }
};

 
  
             
             const mncmccMap = Object.fromEntries(
                        mncmccOptions.map(({ value, label }) => [value, label])
                      );
                      const convertedMap: Map<string, string> = new Map(
   
    Array.from(categoryMap.entries()).map(([key, valueSet]) => [
        
        key, 
       
        Array.from(valueSet).join(', ') 
    ])
);
useEffect(() => {
    if (!pageData.data[0]?.thumbnailS3Path) return

    let revokedUrl: string | null = null

    const fetchImg = async () => {
      try {
        const response = await manualFetch(pageData.data[0]?.thumbnailS3Path, {
          headers: {
            Accept: 'image/*',
          },
        })

        const imageBlob = await response.blob()
        const objectUrl = URL.createObjectURL(imageBlob)
        revokedUrl = objectUrl
        setImageUrl(objectUrl)
      } catch (err) {
        console.error('Image load failed:', err)
      }
    }

    fetchImg()

    return () => {
      if (revokedUrl) {
        URL.revokeObjectURL(revokedUrl)
      }
    }
  }, [pageData.data])
  const handleClickOpen = async (record: any) => {
  // 1. Fetch the images and convert to Blobs/Object URLs
  const fullImgBlob = await fetchImage(record.fullS3Path);
  const thumbImgBlob = await fetchImage(record.thumbnailS3Path);
  const splashImgBlob = await fetchImage(record.splashS3Path);
  const id = record.id;
  const searchParams = new URLSearchParams();

  searchParams.append('img', fullImgBlob);
  searchParams.append('thumbImg', thumbImgBlob);
  searchParams.append('splashImg', splashImgBlob);

  searchParams.append('title', record.title);
  searchParams.append('titleFr', record.titleFr);
  searchParams.append('desc', record.description);
  searchParams.append('descFr', record.descriptionFr);
  searchParams.append('descAr', record.descriptionAr);
  searchParams.append('instruction', record.instruction);
  searchParams.append('instructionFr', record.instructionFr);
  searchParams.append('instructionAr', record.instructionAr);
  searchParams.append('enabled', String(record.enabled));
  searchParams.append('complex', record.complex);
  searchParams.append('retentionDepth', record.retentionDepth);
  searchParams.append('monetizationModel', record.monetizationModel);
  searchParams.append('tier', record.tier);
  searchParams.append('gameLevel', record.gameLevel);
  searchParams.append('orientation', record.orientation);

  record.gameCategories?.forEach((category: string) => 
    searchParams.append('categories', category)
  );

  if (record.accessLevels != null) {
    record.accessLevels.forEach((accessLevel: string) =>
      searchParams.append('accessLevels', accessLevel)
    );
  }

  
  const pathMap: Record<string, string> = {
    'STANDALONE': `/games/edit/${id}`,
    'MAZE': `/maze/edit/${id}`,
    'GUYS': `/survival-zone/edit/${id}`,
    'TREASURE': `/treasure-hunter/edit/${id}`,
  };

  const basePath = pathMap[record.gameType];
  if (basePath) {
    navigate(`${basePath}?${searchParams.toString()}`);
  }
};

  return (
    <>
      <AllGamesReportSearch
        appendSearchForm={appendSearchForm}
        submitSearchForm={submitSearchForm}
      />
      
      <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
  <Col>
    <span style={{fontSize:24 }}>
      Search Results ({pageData.total})
    </span>
  </Col>
  
</Row>
      <DndProvider backend={HTML5Backend}>
        <Table
          className="table-sorting"
          rowKey="eventId"
          dataSource={pageData.data}
          loading={pageData.loading}
          onChange={handleTableChange} 
          pagination={{
            current: parseInt(pageData.query.page) + 1,
            total: pageData.total,
            pageSize: parseInt(pageData.query.pageSize) || 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
           
          }}
        >
          <Column 
    dataIndex="thumbnailS3Path" 
    title="Image" 
    render={(s3Path) => <PrivateImage src={s3Path} height={50} width={50} />} 
  />
          <Column dataIndex="title" title="Game Name"  />
          
          
          <Column dataIndex="tier" title="Game Tier"  />
          <Column 
  dataIndex="gameCategories" 
  title="Category" 
  render={(gameCategories) => 
    (gameCategories && gameCategories.length > 0) 
      ? gameCategories.join(', ') 
      : '-'
  } 
/>
         
          <Column 
  dataIndex="complex" 
  title="Complex" 
  render={(value) => (
    <Tag style={{
      backgroundColor: 'rgba(58, 153, 22, 0.54)', 
      color: '#FFFFFF',                        
      border: 'none',                           
      borderRadius: '20px',
      padding: '4px 12px',
      fontSize: '12px',
      fontWeight: '800',                        
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '60px',
      margin: 0
    }}>
      {value} 
    </Tag>
  )} 
/>
        <Column 
  dataIndex="retentionDepth" 
  title="Retention Depth" 
  render={(value) => (
    <Tag style={{
      backgroundColor: 'rgba(107, 38, 106, 1)', 
      color: '#FFFFFF',                     
      borderRadius: '20px',                  
      padding: '4px 12px',
      fontSize: '12px',
      fontWeight: 'bold',
      border: 'none',                        
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '60px',
      margin: 0                              
    }}>
      {value} 
    </Tag>
  )} 
/>

<Column dataIndex="monetizationModel" title="Monetization"  />

<Column 
  dataIndex="enabled" 
  title="Status" 
  render={(enabled) => (
    <Tag style={{
      backgroundColor: enabled ? 'rgba(58, 153, 22, 0.54)' : 'rgba(153, 22, 64, 0.54)',
      color: '#FFFFFF',          
      border: 'none',            
      borderRadius: '20px',     
      padding: '4px 12px',
      fontSize: '12px',
      fontWeight: '800',         
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '80px',
      margin: 0
    }}>
      {enabled ? 'Active' : 'Inactive'}
    </Tag>
  )} 
/>        
         

          <Column
  title="Action"
  key="action"
  render={(_, record) => (
    <Space size="middle">
      <Tooltip title="Edit Game">
        <EditGradientIcon 
          size={24} 
          onClick={() => handleClickOpen(record)} 
          className="hover-effect" 
        />
      </Tooltip>
    
    </Space>
  )}
/>
        </Table>
      </DndProvider>
    </>
  )
}

AllGamesReportPage.displayName = 'AllGamesReportPage'
export default AllGamesReportPage
